import { isTelemundoVertical } from 'lib/vertical';

const insertInlineNewsletterModule = (article, vertical) => (body) => {
  if (isTelemundoVertical(vertical)) return body;
  const changedBody = [...body];
  const numOfParagraphs = body.filter((item) => item && item.type === 'markup').length;

  const inlineModule = {
    type: 'inlineNewsletter',
    props: { article, vertical },
  };

  if (numOfParagraphs >= 8) {
    const halfWay = Math.floor(numOfParagraphs / 2);
    changedBody.splice(halfWay, 0, inlineModule);
  }

  return changedBody;
};

export default insertInlineNewsletterModule;
